import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { AppErrorBoundary } from './components/admin/ErrorBoundary'
import { setupGlobalErrorHandlers } from './lib/logging'
import { setupChunkErrorHandler, clearChunkErrorState } from './lib/chunkErrorHandler'
import { initSentry } from './lib/sentry'
import App from './App'
import { Toaster } from './components/ui/Toaster'
import './index.css'

// Initialize Sentry before anything else (no-op if VITE_SENTRY_DSN not set)
initSentry()

// Set up chunk error handler (supplements the pre-app handler in index.html)
// This handles errors that occur AFTER React loads (lazy route imports)
setupChunkErrorHandler()

// Set up global error handlers for unhandled promise rejections and errors
setupGlobalErrorHandlers()

// If we got here, the main bundle loaded successfully - clear any reload state
clearChunkErrorState()

// Service Worker cleanup — unregister any existing SW.
// The SW provided negligible caching value (manifest.json + icon) while
// creating stale-chunk deployment risk. The self-destructing sw.js handles
// most cases, but this is belt-and-suspenders for edge cases where the
// browser doesn't fetch the updated sw.js.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (const registration of registrations) {
      registration.unregister()
    }
  }).catch(() => {
    // Ignore — SW API not available or blocked
  })
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <App />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </AppErrorBoundary>
  </React.StrictMode>,
)
